import script from "./DomainRemovalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainRemovalModal.vue?vue&type=script&setup=true&lang=js"

import "./DomainRemovalModal.vue?vue&type=style&index=0&id=7d5547cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5547cd"]])

export default __exports__